import {Observable, Subject} from "rxjs";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ToggleSidebarService {
  private readonly toggled = new Subject<void>();

  public get toggled$(): Observable<void> {
    return this.toggled.asObservable();
  }

  public nextToggle() {
    this.toggled.next();
  }
}
